// tablecollaborator.js

import ActionsForm from '@/shared/mixins/actionsForm'
import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'
import { toast, loading } from '@/shared/utils/UIHelper'
import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm.js'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import EmployeeRepository from '@/shared/http/repositories/business/employee.js'
import TableReinforcement from '@/views/private/miscellaneousreimbursement/components/tablecollaborator/tableReinforcement.vue'
import ReinforcementRepository from '@/shared/http/repositories/access/reinforcement'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import Tools from '@/components/tools/Tools.js'
import PermissionMixin from '@/store/module/permission/mixin'

export default {
  name: 'tablecollaborator',
  mixins: [ActionsForm, PermissionMixin],
  components: {
    AutocompleteZ,
    TableReinforcement
  },
  props: {
    // Quando true (tela de CONSULTA de Despesas Diversas) o componente e read-only:
    // esconde todas as colunas de acao (editar/reforco/excluir/bloquear/adicionar).
    isConsulta: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      bloqueiCriacaoReforco: false,
      Reforcovalor: null,
      nameArquivo: '',
      exclusao: false,
      reforco: false,
      reforcoID: null,
      empresareforcoId: null,
      AtualizaPrestacao: false,
      AtualizaReforco: false,
      ArrayFuncionarioImpossibilitado: [],
      espacos: [],
      ObjLoteNovoFuncionario: {},
      arquivo: '',
      base64: '',
      arquivosId: null,
      funcionarioId: null,
      details: [],
      verificarFluxo: 0,
      ObjRefoco: [],
      funcionarioAdiantamentoId: null,
      formSearch: {},
      dataCollaborator: [],
      AdiantamentoFormatado: null,
      EnumInfo: [],
      allGroup: [],
      editinfo: {
        valorLimiteDespesa: null,
        Adiantamento: null,
        funcionario: {
          cargo: {
            nome: null
          }
        }
      },
      editinfo2: {
        Adiantamento: null,
        AdiantamentoDiversos: null
      },
      formAddDe: {
        TelefoneCelular: '',
        objnomeFuncionarios: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        TipoDespesa: 'DespesasDiverso',
        Adiantamento: null,
        AdiantamentoDiversos: null,
        empresaId: null,
        empresareforcoId: '',
        cargoId: null,
        contaId: null,
        Senha: '',
        Username: '',
        ConfSenha: '',
        Email: '',
        arquivocomprovante: {},
        saldo: false,
        saldoValor: null
      },
      nomeCargo: '',
      disableDados: false,
      valorAdiantamentoEnum: [],
      valorAdiantamentoDiversosEnum: [],
      valorLimiteDespesa: [],
      senhaNaoConfere: undefined,
      datadespesaEdit: {
        statusDespesa: 0
      },
      reforcoDto: {
        valorReforco: null
      },
      arquivocomprovante: null,
      reforcovalue: null,
      dataReforco: [],
      lock: {
        motivoBloqueio: '',
        Bloqueado: false
      },
      PopupmotivoBloqueio: '',
      iconLock: null,
      objColaborador: {},
      verificaBloqueio: false,
      deletingColaborators: {}
    }
  },
  mounted () {
    this.onLoad()
    this.GetEnumValorAdiantamento()
    this.GetEnumValue()
  },
  computed: {
    moneyOpts () {
      return Tools.moneyFormatHtml()
    }
  },
  methods: {
    redirectToCollaboratorDetails (collabId) {
      // SEM consulta=1 de proposito: `CollaboratorTableTravelExpenseEmployeSeveral` nao le
      // `isConsulta` (auditado: so `showModal`, `gerarPdf` e `$router.back()`, zero escrita),
      // entao o parametro cairia no vazio. O par de Lotes Pagos anexa porque LA tem consumidor.
      this.$router.push(`/despesa/diversos/colaborador/detalhes/funcionario?funcionario=${collabId}`)
    },
    // openModalDelete (value) {
    //   let FuncionarioId = value.funcionarioId
    //   if (value.funcionarioAdiantamento === null) {
    //     this.funcionarioAdiantamentoId = null
    //   } else {
    //     this.funcionarioAdiantamentoId = value.funcionarioAdiantamentoId
    //   }
    //   loading.push()
    //   if (FuncionarioId != null && FuncionarioId !== undefined) {
    //     EmployeeRepository.Exclusao(this.funcionarioAdiantamentoId, FuncionarioId, this.CompanySelected)
    //       .then(Response => {
    //         if (Response.data) {
    //           loading.close()
    //           this.onLoad()
    //           toast.success('Despesa Diversos excluida com sucesso')
    //         }
    //       })
    //       .catch((Error) => {
    //         this.$refs['add-despesa'].hide()
    //         loading.close()
    //         toast.error('Erro ao excluir')
    //       })
    //   } else {
    //     loading.close()
    //     toast.error('Erro ao excluir')
    //   }
    // },
    // GetAllGroup () {
    //   TravelExpenseRepository.GetAllGroup()
    //     .then((response) => {
    //       this.allGroup = response.data
    //     })
    // },

    verificaConfSenha (funcionarioId) {
      if (this.formAddDe.Senha === this.formAddDe.ConfSenha) {
        this.senhaNaoConfere = false
        this.verificaEspacos(funcionarioId)
      } else {
        this.senhaNaoConfere = true
        toast.error('Os campos senha e confirma senha não Coincidem')
      }
    },

    gerarLote () {
      this.formSearch.CompanyID = this.CompanySelected
      loading.push()
      MiscellaneousExpensesRepository.GenerateLoteNovoFuncionario(this.CompanySelected)
        .then((Response) => {
          this.onDownloadExcel(Response)
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },

    onDownloadExcel (response) {
      const obj = response.data.data
      const contentType = obj.contentType
      const data = Uint8Array.from(atob(obj.file), c => c.charCodeAt(0))
      var a = window.document.createElement('a')
      a.href = window.URL.createObjectURL(new Blob([data], { type: contentType }))
      a.download = obj.name
      document.body.appendChild(a)
      a.click()
      // toast.success('Arquivo gerado com sucesso!')
      // loading.close()
      this.objList.forEach(element => {
        element.checked = false
      })
    },
    verificaEspacos (funcionarioid) {
      let usarname = this.formAddDe.Username
      const regex = /\s+/g
      this.espacos = usarname.match(regex)

      if (this.espacos != null) {
        if (this.espacos.length !== 0) {
          toast.error('O campo Usarname não pode conter espaços, de preferência utilize o cpf ou email')
        }
      } else {
        this.AdicionarConta(funcionarioid)
      }
    },

    EditaAdiantamento (funcionarioId) {
      let companyid = this.CompanySelected
      if (this.editinfo2.AdiantamentoDiversos != null) {
        this.editinfo2.AdiantamentoDiversos = parseInt(this.editinfo2.AdiantamentoDiversos)
        this.editinfo2.TipoDespesa = 'DespesasDiverso'
        loading.push()
        var formData = new FormData()
        formData.append('funcionariDtoJson', JSON.stringify(this.editinfo2))
        if (this.arquivocomprovante !== null) {
          formData.append('file', this.arquivocomprovante.data)
        }
        EmployeeRepository.AlteraValorAdiantamento(funcionarioId, companyid, formData)
          .then(Response => {
            this.$refs['edit-despesa'].hide()
            this.onLoad()
            toast.success('Edição feita com sucesso')
            loading.close()
            if (Response.data) {
            } else {
              this.onLoad()
              this.editinfo2.AdiantamentoDiversos = null
              this.editinfo2.Adiantamento = null
              loading.close()
              this.base64 = ''
              this.arquivo = ''
            }
          })
          .catch((Error) => {
            toast.warning(Error.response.data)
            loading.close()
          })
      } else {
        toast.warning('Escolha o valor do novo adiantamento')
      }
    },

    limpaCampos () {
      this.editinfo2.AdiantamentoDiversos = ''
      // this.zerarAutocomplete()
      this.formAddDe.nomeCargo = ''
      this.formAddDe.cargoId = null
      this.disableDados = false
      this.formAddDe.Adiantamento = null
      this.editinfo2.Adiantamento = null
      this.verificarFluxo = 0
      this.formAddDe.nomeCargo = ''
      this.formAddDe.TelefoneCelular = null
      this.formAddDe.Senha = null
      this.formAddDe.ConfSenha = null
      this.formAddDe.Username = null
      this.formAddDe.Email = null
      this.arquivocomprovante = null
      if (this.$refs.favorecidoTypaehead !== undefined) {
        this.$refs.favorecidoTypaehead.clear()
      }
    },
    PopupFuncionarioConta () {
      this.verificarFluxo = 0
      this.formAddDe.nomeCargo = ''
      this.formAddDe.TelefoneCelular = null
      this.formAddDe.Senha = null
      this.formAddDe.ConfSenha = null
      this.formAddDe.Username = null
      this.formAddDe.Email = null
    },

    AdicionarConta (funcionarioId) {
      if (this.formAddDe.objnomeFuncionarios !== '' && this.formAddDe.TelefoneCelular !== '' && this.formAddDe.Senha !== '' && this.formAddDe.Email !== '') {
        loading.push()
        var formData = new FormData()
        this.formAddDe.empresaId = this.CompanySelected
        formData.append('contaGeraDtoJson', JSON.stringify(this.formAddDe))
        EmployeeRepository.PostContaGera(funcionarioId, formData)
          .then(Response => {
            this.$refs.tableGridsColaborador.LoadAllByData(Response)
            if (Response.data) {
              this.onLoad()
              toast.success('Conta criada com sucesso')
              this.$refs['add-conta'].hide()
              this.limpaCampos()
              loading.close()
            }
          })
          .catch((Error) => {
            if (Error.response.data === null && Error.response.data === undefined) {
              toast.error('Erro ao criar a conta')
              loading.close()
            } else {
              toast.warning('Username existente, escolha outro!')
              loading.close()
            }
          })
      } else {
        toast.warning('Preencha todas as informações')
      }
    },
    voltar () {
      this.$refs['add-conta'].hide()
      this.$refs['add-despesa'].show()
      this.editinfo2.Adiantamento = null
      this.zerarAutocomplete()
      this.verificarFluxo = 0
      this.formAddDe.TelefoneCelular = null
      this.formAddDe.Senha = null
      this.formAddDe.ConfSenha = null
      this.arquivocomprovante = null
      this.formAddDe.Username = null
      this.formAddDe.Email = null
    },
    AdicionarFuncionario (funcionarioId) {
      if (this.formAddDe.objnomeFuncionarios != null && this.formAddDe.objnomeFuncionarios !== '' && this.formAddDe.objnomeFuncionarios !== undefined && this.formAddDe.cargoId != null && this.formAddDe.cargoId !== undefined && funcionarioId != null) {
        loading.push()

        var formData = new FormData()
        if (this.editinfo2.Adiantamento !== null && this.editinfo2.Adiantamento !== undefined) {
          this.formAddDe.AdiantamentoDiversos = parseInt(this.editinfo2.Adiantamento)
          this.editinfo2.AdiantamentoDiversos = this.editinfo2.Adiantamento
          this.formAddDe.saldoValor = parseFloat(this.formAddDe.saldoValor)
        }
        if (typeof this.formAddDe.objnomeFuncionarios !== 'string') {
          this.formAddDe.objnomeFuncionarios = this.formAddDe.objnomeFuncionarios.nome
        }
        this.formAddDe.EmpresaID = this.CompanySelected
        this.formAddDe.empresaId = this.CompanySelected
        formData.append('funcionariDtoJson', JSON.stringify(this.formAddDe))
        if (this.arquivocomprovante !== null) {
          formData.append('file', this.arquivocomprovante.data)
        }
        this.exclusao = false
        if (this.verificarFluxo === 0) {
          EmployeeRepository.PostAddFuncionario(funcionarioId, this.CompanySelected, formData)
            .then(Response => {
              if (Response.data) {
                loading.pop()
                this.formAddDe.funcionarioId = Response.data.funcionario.id
                if (Response.data.conta != null && Response.data.conta !== undefined) {
                  toast.success('Funcionário adicionado com sucesso')
                  this.onLoad()
                  this.AtualizaPrestacao = !this.AtualizaPrestacao
                  this.$emit('AtualizaPrestacao', this.AtualizaPrestacao)
                  this.$refs['add-despesa'].hide()
                  this.cancelNewBrower()
                } else {
                  loading.pop()
                  this.verificarFluxo = 1
                  toast.warning('Funcionário sem Conta, Contate a Equipe de TI')
                  this.$refs['add-despesa'].hide()
                  this.cancelNewBrower()
                  this.$refs['warning-support'].show()
                }
              }
            })
            .catch((Error) => {
              if (Error.response.data.Message != null && Error.response.data.Message !== undefined) {
                loading.pop()
                this.cancelNewBrower()
                toast.warning(Error.response.data.Message)
                let funcionarioid = this.funcionarioId
                this.GetFuncionariosImpossibilitados({FuncionarioId: funcionarioid, EmpresaId: this.CompanySelected})
                this.$refs['add-despesa'].hide()
              } else {
                loading.pop()
                this.cancelNewBrower()
                toast.error('Erro ao criar')
              }
            })
        } else {
          toast.warning('Funcionário sem Conta, Contate a Equipe de TI')
          this.$refs['add-despesa'].hide()
          this.$refs['warning-support'].show()
          loading.close()
        }
      } else {
        toast.warning('Preencha o nome do funcionário e sua função')
      }
    },

    GetFuncionariosImpossibilitados (data) {
      loading.push()
      this.$refs['add-travel-modal-erro'].show()
      AcceptanceTermRepository.FuncionarioImpossibilitado(data)
        .then(Response => {
          this.ArrayFuncionarioImpossibilitado = Response.data
          if (this.ArrayFuncionarioImpossibilitado.saldoPrimeiroAiantamento !== undefined) {
            this.reforco = true

            if (this.ArrayFuncionarioImpossibilitado.saldoPrimeiroAiantamento.length === 0) {
              this.ArrayFuncionarioImpossibilitado.saldoPrimeiroAiantamento = null
            }
          } else {
            if (this.ArrayFuncionarioImpossibilitado.despesasViagem.length === 0) {
              this.ArrayFuncionarioImpossibilitado.despesasViagem = null
            }

            if (this.ArrayFuncionarioImpossibilitado.despesasDiversos.length === 0) {
              this.ArrayFuncionarioImpossibilitado.despesasDiversos = null
            }

            if (this.ArrayFuncionarioImpossibilitado.termoAceite.length === 0) {
              this.ArrayFuncionarioImpossibilitado.termoAceite = null
            }

            if (this.ArrayFuncionarioImpossibilitado.despesa.length === 0) {
              this.ArrayFuncionarioImpossibilitado.despesa = null
            }
            this.ArrayFuncionarioImpossibilitado.saldoPrimeiroAiantamento = null
          }
          loading.close()
        })
        .catch(Error => {
          toast.error(Error.response.data)
          loading.close()
        })
    },
    cancelNewBrower () {
      this.$refs['add-despesa'].hide()
      this.zerarAutocomplete()
      this.formAddDe.nomeCargo = ''
      this.formAddDe.cargoId = null
      this.verificarFluxo = 0
      this.disableDados = false
      this.formAddDe.Adiantamento = null
      this.editinfo2.Adiantamento = null
      if (this.$refs.favorecidoTypaehead !== undefined) {
        this.$refs.favorecidoTypaehead.clear()
      }
      this.arquivocomprovante = null
    },
    GetEnumValorAdiantamento () {
      MiscellaneousExpensesRepository.GetEnumValorAdiantamentoDiversos()
        .then(Response => {
          this.valorAdiantamentoEnum = Response.data
          if (this.$store.getters['company/company'].localidade === 'escl') {
            this.valorAdiantamentoEnum = this.valorAdiantamentoEnum.filter(data => data.text.includes('CLP'))
          } else {
            this.valorAdiantamentoEnum = this.valorAdiantamentoEnum.filter(data => data.text.includes('R$'))
          }
          this.editinfo2.Adiantamento = Response.data[10] ? Response.data[10].obj : null
        })
    },
    openModal () {
      this.$refs['add-despesa'].show()
      this.selected = ''
      this.contato = ''
      this.editinfo2.Adiantamento = null
      this.formAddDe.objnomeFuncionarios = []
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    GetLoteNovoFuncionarioByFuncionarioId (funcionarioId) {
      EmployeeRepository.GetLoteNovoFuncionarioByFuncionarioId(funcionarioId)
        .then(Response => {
          this.ObjLoteNovoFuncionario = Response.data
        })
    },
    openModalEdit (value) {
      this.GetLoteNovoFuncionarioByFuncionarioId(value.funcionarioId)
      this.editinfo = value
      if (value.adiantamentoDiversos !== undefined && value.adiantamentoDiversos !== null) {
        this.editinfo2.Adiantamento = value.adiantamentoDiversos
        this.editinfo2.AdiantamentoDiversos = value.adiantamentoDiversos
      } else {
        this.editinfo2.Adiantamento = null
      }
      this.$refs['edit-despesa'].show()
    },

    openModalReinforcement (value) {
      this.ObjRefoco = value
      this.funcionarioId = value.funcionarioId
      this.empresareforcoId = this.CompanySelected
      this.editinfo = value
      if (value.adiantamentoDiversos !== undefined && value.adiantamentoDiversos !== null) {
        this.editinfo2.Adiantamento = value.adiantamentoDiversos
      } else {
        this.editinfo2.Adiantamento = null
      }
      this.$refs['reinforcement-despesa'].show()
    },

    openModalReinforcementValue (data) {
      this.dataReforco = this.ObjRefoco
      this.$refs['reinforcement-despesa-value'].show()
    },
    openModalReinforcementEdit (funcionarioId) {
      this.dataReforco = funcionarioId
      this.Reforcovalor = this.dataReforco.valorReforco
      this.$refs['reinforcement-despesa-edit'].show()
    },

    verificacaoArquivoidDomwload (value) {
      this.funcionarioId = value.funcionarioId
      this.GetArquivosId(value.funcionarioId)
    },

    openModalDownload (arquivoId) {
      if (arquivoId == null) {
        toast.warning('Funcionário sem anexo')
      } else {
        this.$refs['download-despesa'].show()
        this.postDonwload()
      }
    },

    GetArquivosId (funcionarioId) {
      EmployeeRepository.GetAnexoFuncionarioById(funcionarioId)
        .then((response) => {
          if (response.data.length <= 0) {
            this.arquivosId = null
          } else {
            this.arquivosId = response.data[0].arquivoID
          }
          this.openModalDownload(this.arquivosId)
        })
    },
    postDonwload () {
      if (this.arquivosId != null) {
        loading.push()
        EmployeeRepository.PosDonwload(this.arquivosId, this.CompanySelected)
          .then(Response => {
            if (Response.data) {
              this.base64 = Response.data
              loading.close()
            }
          })
          .catch((Error) => {
            toast.error('Erro ao fazer Donwload')
            loading.close()
          })
      } else {
        toast.warning('Sem arquivos para baixar')
      }
    },

    verificacaoArquivoidDomwloadReforco (value) {
      this.reforcoID = value.reforcoid
      this.GetArquivosReforcoId(this.reforcoID)
    },
    GetArquivosReforcoId (reforcoId) {
      ReinforcementRepository.GetAnexoReforcoById(reforcoId)
        .then((response) => {
          if (response.data.length <= 0) {
            this.arquivosId = null
            this.openModalDownloadReforco()
          } else {
            this.nameArquivo = response.data[0].name
            this.arquivosId = response.data[0].id
          }
          this.openModalDownloadReforco(this.arquivosId)
        })
    },
    openModalDownloadReforco (arquivoId) {
      if (arquivoId == null) {
        toast.warning('Funcionário sem anexo')
      } else {
        this.$refs['download-despesa'].show()
        this.postDonwloadReforco()
      }
    },
    cancelDownloadReforcoBrower () {
      this.$refs['download-reforco'].hide()
    },
    postDonwloadReforco () {
      if (this.arquivosId != null) {
        loading.push()
        ReinforcementRepository.PosDonwload(this.arquivosId, this.CompanySelected)
          .then(Response => {
            if (Response.data) {
              this.base64 = Response.data
              loading.close()
            }
          })
          .catch((Error) => {
            toast.error('Erro ao fazer Donwload')
            loading.close()
          })
      } else {
        toast.warning('Sem arquivos para baixar')
      }
    },

    downloadComprovante () {
      if (this.base64 != null) {
        var a = document.createElement('a')
        const typefile = 'v,slv'.includes('.pdf') ? 'application/pdf' : 'image/png'
        a.href = `data:${typefile};base64,` + this.base64
        a.download = this.arquivo
        a.click()
        toast.success('Sucesso ao fazer o Donwload')
      } else {
        toast.warning('Erro ao fazer Donwload')
      }
    },

    GetEnumValue () {
      TravelExpenseRepository.GetValorAdiantamento()
        .then((response) => {
          this.EnumInfo = response.data
          if (this.editinfo.valorLimiteDespesa === 200) {
          }
        })
    },

    cancelEditBrower () {
      this.$refs['edit-despesa'].hide()
    },
    cancelReinforcementBrower () {
      this.$refs['reinforcement-despesa'].hide()
    },
    cancelDownloadBrower () {
      this.$refs['download-despesa'].hide()
      this.arquivosId = null
      this.base64 = null
    },
    cancelReinforcementValue () {
      this.$refs['reinforcement-despesa-value'].hide()
    },
    cancelReinforcementEdit () {
      this.limpaCamposReforco()
      this.$refs['reinforcement-despesa-edit'].hide()
    },
    onSearchFavorecido (value) {
      this.funcionarioId = null
      let el = document.getElementById('cargoSelecionado')
      el.classList.remove('input-funcao-cargo-bloc')
      el.classList.add('input-funcao-cargo')

      let ele = document.getElementById('cargo')
      ele.classList.remove('input-funcao-cargo')
      ele.classList.add('input-funcao-cargo-bloc')
      loading.push()
      EmployeeRepository.GetAllResponsiblePaging(value, 50, 1)
        .then((response) => {
          if (response.data.data.length > 0) {
            this.registrofuncionario = true
            this.$refs.favorecidoTypeaheadPoup.data = response.data.data
            // this.formAddDe.objnomeFuncionarios = response.data.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onSearchCargo (value) {
      loading.push()
      TravelExpenseRepository.GetAllCargo(value)
        .then((response) => {
          if (response.data.length > 0) {
            this.$refs.favorecidooTypeaheadPoup.data = response.data
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    onChangeCodeFavorecido (value) {
      this.funcionarioId = null
      let el = document.getElementById('cargoSelecionado')
      el.classList.remove('input-funcao-cargo-bloc')
      el.classList.add('input-funcao-cargo')

      let ele = document.getElementById('cargo')
      ele.classList.remove('input-funcao-cargo')
      ele.classList.add('input-funcao-cargo-bloc')
      loading.push()
      EmployeeRepository.GetResponsibleByCode(value)
        .then((response) => {
          if (response.data.code > 0) {
            this.$refs.favorecidoTypeaheadPoup.setValue(response.data.data[0])
            // this.registrofuncionario = true
            // this.$refs.favorecidoTypeaheadPoup.data = response.data.data
            // this.formAddDe.objnomeFuncionarios = response.data.data
            this.GetCargobyId(response.data.data[0])
          }
          loading.close()
        }).catch(err => {
          console.log(err)
          this.zerarAutocomplete()
          loading.close()
        })
    },
    GetCargobyId (data) {
      let el = document.getElementById('cargoSelecionado')
      el.classList.remove('input-funcao-cargo')
      el.classList.add('input-funcao-cargo-bloc')

      let ele = document.getElementById('cargo')
      ele.classList.remove('input-funcao-cargo-bloc')
      ele.classList.add('input-funcao-cargo')
      this.nomeCargo = data.cargo.nome
      this.funcionarioId = data.id
      this.formAddDe.contaId = data.contaID
      this.formAddDe.cargoId = data.cargo.id

      if (this.nomeCargo !== null || this.nomeCargo !== undefined) {
        this.disableDados = true
      } else {
        this.nomeCargo = ''
        this.disableDados = false
      }
    },
    getInput (data) {
      this.formAddDe.objnomeFuncionarios = data
    },
    getcargoId (data) {
      this.formAddDe.cargoId = data.id
    },
    onLoad () {
      loading.push()
      if (this.formSearch.FuncionarioID) {
        MiscellaneousExpensesRepository.GetAllColaboratorDespesaDiversosFuncionarioId(this.CompanySelected, this.formSearch, this.$refs.tableGridsColaborador.pagingLimit, this.$refs.tableGridsColaborador.pagingIndex)
          .then((Response) => {
            loading.pop()
            this.dataCollaborator = Response.data.data
            this.$refs.tableGridsColaborador.LoadAllByData(Response)
          })
          .finally(() => { loading.pop() })
      } else {
        MiscellaneousExpensesRepository.GetAllPaging(this.CompanySelected, this.$refs.tableGridsColaborador.pagingLimit, this.$refs.tableGridsColaborador.pagingIndex)
          .then((Response) => {
            this.$refs.tableGridsColaborador.LoadAllByData(Response)
            loading.pop()
            this.dataCollaborator = Response.data.data
          })
          .catch((Error) => {
            loading.pop()
          })
      }
    },
    formataData (value) {
      if (value !== '-') {
        var data = new Date(value)
        var dia = data.getDate()
        var mes = data.getMonth() + 1
        var ano = data.getFullYear()
        var dataFormatada = dia.toString().padStart(2, '0') + '/' + mes.toString().padStart(2, '0') + '/' + ano
        return dataFormatada
      } else {
        return 'N/D'
      }
    },
    addModalColaborador () {
      this.$refs['modal-add-colaborador'].show()
    },
    zerarAutocomplete () {
      this.formAddDe.objnomeFuncionarios = []
    },
    openDetailsimg () {
      this.$refs['Detailsimg'].show()
    },
    addIma () {
      document.getElementById('input-build').click()
    },
    saveBuild (e) {
      let UrlConvert = URL.createObjectURL(e.target.files[0])
      let obj = {
        data: e.target.files[0],
        url: UrlConvert
      }
      let conf = {
        headers: {
          'Content-Type': 'multipart/form- data'
        }
      }
      this.arquivocomprovante = obj
      console.log(obj)
      console.log(conf)
      let img = new FormData()
      img.append('img', obj.data)
      // FileEnterpriseRepository.SendImgWithEmpreendimentoidConstructions(this.data.id, img, conf)
      //   .then(Response => {
      //     this.getImg()
      //     loading.pop()
      //   })
      //   .catch(Error => loading.pop())
    },

    limpaCamposReforco () {
      this.dataReforco = []
    },
    tableReinforcement () {
      this.dataReforco.valorReforco = this.Reforcovalor
      if (this.dataReforco.valorReforco != null && this.arquivocomprovante !== null) {
        this.dataReforco.empresaID = this.CompanySelected
        this.dataReforco.Diversos = true
        loading.push()
        var formData = new FormData()
        formData.append('file', this.arquivocomprovante.data)

        console.log(this.dataReforco.funcionarioId)
        formData.append('reforco', JSON.stringify(this.dataReforco))
        ReinforcementRepository.PostReforco(this.dataReforco, formData)
          .then(Response => {
            toast.success('Reforço incluido com sucesso')
            this.arquivocomprovante = null
            this.$emit('AtualizaPrestacao', this.AtualizaPrestacao)
            this.AtualizaReforco = !this.AtualizaReforco
            this.$emit('AtualizaReforco', this.AtualizaReforco)
            this.$refs['reinforcement-despesa-value'].hide()
            this.limpaCamposReforco()
            loading.close()
          })
          .catch((Error) => {
            if (Error.response.data.Message != null && Error.response.data.Message !== undefined) {
              loading.pop()
              this.arquivocomprovante = null
              toast.warning(Error.response.data.Message)
              let funcionarioid = this.funcionarioId
              this.GetFuncionariosImpossibilitados({FuncionarioId: funcionarioid, EmpresaId: this.CompanySelected, Reforco: true})
              this.$refs['reinforcement-despesa-value'].hide()
            } else {
              this.arquivocomprovante = null
              loading.pop()
              this.$refs['reinforcement-despesa-value'].hide()
              toast.error('Erro ao criar o Reforço')
            }
          })
      } else {
        toast.warning('Preencha todas as informações')
      }
    },
    GetReforco () {
      ReinforcementRepository.GetReforcoById(this.funcionarioId, this.$refs.TabledetailsTabReforco.pagingLimit, this.$refs.TabledetailsTabReforco.pagingIndex)
        .then(Response => {
          this.$refs.TabledetailsTabReforco.LoadAllByData(Response)
          this.details = Response.data.data
          const temStatus1 = Response.data.data.some(obj => obj.status === 1 || obj.situacao === 'AG. APROVAÇÃO')
          if (temStatus1 === true) {
            this.bloqueiCriacaoReforco = true
          } else {
            this.bloqueiCriacaoReforco = false
          }
        })
    },

    EditaReforco () {
      this.dataReforco.valorReforco = this.Reforcovalor
      if (this.dataReforco.valorReforco != null) {
        loading.push()
        var formData = new FormData()
        if (this.arquivocomprovante !== null) {
          formData.append('file', this.arquivocomprovante.data)
        }
        this.dataReforco.empresaID = this.CompanySelected
        formData.append('reforco', JSON.stringify(this.dataReforco))
        ReinforcementRepository.AlteraValorReforco(this.dataReforco.reforcoid, this.funcionarioId, formData)
          .then(Response => {
            this.$refs['reinforcement-despesa-value'].hide()
            this.onLoad()
            this.arquivocomprovante = null
            toast.success('Edição feita com sucesso')
            loading.close()
            this.cancelReinforcementEdit()
            if (Response.data) {
            } else {
              this.onLoad()
              loading.close()
            }
          })
          .catch((Error) => {
            this.arquivocomprovante = null
            toast.warning(Error.response.data)
            loading.close()
          })
      } else {
        toast.warning('Escolha o valor do novo Reforço')
      }
    },
    checkBlock (value) {
      this.objColaborador = value
      if (this.objColaborador.contas[0].bloqueado === false) {
        this.ModalLock()
      } else {
        this.LockCollaborator()
      }
    },
    ModalLock (value) {
      this.objColaborador = value
      this.$refs['DetailsLock'].show(value)
    },
    CloseModalLock () {
      this.PopupmotivoBloqueio = ''
      this.$refs['DetailsLock'].hide()
    },
    LockCollaborator () {
      loading.push()
      // var iconLock = document.getElementById('locked')
      var formData = new FormData()
      var bloqueioconta = this.objColaborador.contaId
      console.log(bloqueioconta)
      if (this.objColaborador.bloqueado === false) {
        this.lock.Bloqueado = true
      } else {
        this.lock.Bloqueado = false
      }
      this.lock.motivoBloqueio = this.PopupmotivoBloqueio
      formData.append('bloqueioZpagDto', JSON.stringify(this.lock))
      EmployeeRepository.BloqueioZpagFuncionario(bloqueioconta, formData)
        .then(Response => {
          if (this.lock.Bloqueado === true) {
            toast.success('Colaborador Bloqueado com sucesso')
            this.CloseModalLock()
          }
          if (this.lock.Bloqueado === false) {
            toast.success('Colaborador Desbloqueado com sucesso')
            this.CloseModalLock()
          }
          this.onLoad()
          loading.close()
        })
        .catch((Error) => {
          toast.warning(Error)
          this.CloseModalLock()
          loading.close()
        })
    },
    openDeletePopup (value) {
      this.deletingColaborators = value
      console.log(value)
      this.$refs['delete-despesa'].show()
    },
    cancelDeletepopup () {
      this.$refs['delete-despesa'].hide()
    },
    ConfirmDelete () {
      let FuncionarioId = this.deletingColaborators.funcionarioId
      if (this.deletingColaborators.funcionarioAdiantamento === null) {
        this.funcionarioAdiantamentoId = null
      } else {
        this.funcionarioAdiantamentoId = this.deletingColaborators.funcionarioAdiantamentoId
      }
      this.exclusao = true
      loading.push()
      if (FuncionarioId != null && FuncionarioId !== undefined) {
        EmployeeRepository.Exclusao(this.funcionarioAdiantamentoId, FuncionarioId, this.CompanySelected, true)
          .then(Response => {
            if (Response.data) {
              loading.close()
              this.onLoad()
              toast.success('Colaborador excluido com sucesso')
              this.$refs['delete-despesa'].hide()
            }
          })
          .catch((Error) => {
            loading.close()
            this.$refs['delete-despesa'].hide()
            this.GetFuncionariosImpossibilitados({FuncionarioId: FuncionarioId, EmpresaId: this.CompanySelected})
            toast.warning(Error.response.data == null || Error.response.data === undefined ? 'Erro ao excluir' : Error.response.data)
          })
      } else {
        loading.close()
        toast.error('Erro ao excluir')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/tablecollaborator/tablecollaborator.js